import React, { useState } from "react";
import logo from "../assets/logoD.png";
import { FaBars, FaChevronDown } from "react-icons/fa"; // Importing the arrow icon
import { IoCloseCircleOutline } from "react-icons/io5";
import { LuDownload } from "react-icons/lu";
import { MdLocalPhone } from "react-icons/md";
import call from "../assets/call.gif";
import Popup from "./Popup";

import { IoCallOutline } from "react-icons/io5";
const Navbar = () => {
  const [isProjectsHovered, setIsProjectsHovered] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false); // state for popup

  const handleBookNowClick = () => {
    setIsPopupOpen(true); // Trigger popup on "Book Now" click
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false); // Close popup
  };

  const handleDropdownToggle = (e) => {
    setDropdownOpen(!isDropdownOpen);
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleDownloadBrochure = () => {
    const pdfUrl = "/brochure.pdf";

    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = "Siddhi Ganapathi Brochure.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleScroll = (e, targetId) => {
    e.preventDefault();
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      const targetPosition =
        targetElement.getBoundingClientRect().top + window.pageYOffset;

      const offset = 80;
      const scrollToPosition = targetPosition - offset;

      window.scrollTo({
        top: scrollToPosition,
        behavior: "smooth",
      });
    }

    if (isOpen) {
      setIsOpen(false); // Close the menu after navigation in mobile view
    }
  };

  return (
    <div className="bg-[#fdf4e3] text-black fixed top-0 w-full z-50 shadow-md">
      <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
        {/* Logo */}
        <div className="flex ">
          <img src={logo} className="w-[60%] md:w-[50%]" alt="Logo" />
          {/* Call Us Button (Mobile Only) */}
          <a
            href="tel:+919160077777"
            className="md:hidden flex items-center space-x-2 bg-white  text-[#03833e] rounded-[15px] ml-[8%] h-[40px] p-[3px] mt-[5%]"
          >
            {/* <MdLocalPhone className="  text-[#03833e]  " /> */}
            {/* <img src={call} className="w-[40%] rounded-[50%] ml-[30%]" /> */}
            <IoCallOutline className="  font-semibold text-2xl" />
            <p className="font-semibold">Call Us</p>
          </a>
        </div>

        {/* Navbar Menu for Desktop */}
        <div className="hidden md:flex space-x-6">
          <a
            href="#home"
            onClick={(e) => handleScroll(e, "home")}
            className="hover:text-green-500 transition font-semibold"
          >
            Home
          </a>
          <a
            href="#about"
            onClick={(e) => handleScroll(e, "about")}
            className="hover:text-green-500 transition font-semibold"
          >
            About
          </a>

          {/* Projects Dropdown */}
          <div
            className="relative"
            onMouseEnter={() => setIsProjectsHovered(true)} // Show dropdown on hover
            onMouseLeave={() => setIsProjectsHovered(false)} // Hide dropdown when mouse leaves
          >
            <button
              className="flex items-center hover:text-green-500 transition font-semibold"
              onClick={(e) => handleDropdownToggle(e)}
            >
              Projects
              <FaChevronDown
                className={`ml-1 transition-transform ${
                  isProjectsHovered ? "rotate-180" : "rotate-0"
                }`} // Rotate the arrow when hovered
              />
            </button>

            {/* Dropdown Menu */}
            <div
              className={`${
                isProjectsHovered ? "block" : "hidden"
              } absolute bg-white border shadow-lg rounded-md`}
            >
              <a
                href="#ongoingProjects"
                onClick={(e) => handleScroll(e, "ongoingProjects")}
                className="block px-4 py-2 text-black hover:bg-gray-200"
              >
                Ongoing Projects
              </a>
              <a
                href="#upcomingProjects"
                onClick={(e) => handleScroll(e, "upcomingProjects")}
                className="block px-4 py-2 text-black hover:bg-gray-200"
              >
                Upcoming Projects
              </a>
              <a
                href="#completedProjects"
                onClick={(e) => handleScroll(e, "completedProjects")}
                className="block px-4 py-2 text-black hover:bg-gray-200"
              >
                Completed Projects
              </a>
            </div>
          </div>
          <a
            href="#plots"
            onClick={(e) => handleScroll(e, "plots")}
            className="hover:text-green-500 transition font-semibold"
          >
            Layout
          </a>
          {/* Contact */}
          <a
            href="#contact"
            onClick={(e) => handleScroll(e, "contact")}
            className="hover:text-green-500 transition font-semibold "
          >
            Contact
          </a>
        </div>
        <div className="hidden md:flex space-x-2">
          <a onClick={handleDownloadBrochure} className="cursor-pointer ">
            <p className="flex bg-green-500 hover:bg-green-600 p-2 rounded-[10px] text-white h-[35px]">
              Download Brochure{" "}
              <LuDownload className="block group-hover:hidden mt-[1.3%]" />
            </p>
          </a>
          <a onClick={handleBookNowClick} className="cursor-pointer">
            <p className="flex bg-green-500 hover:bg-green-600 p-2 rounded-[10px] text-white">
              Book Now
            </p>
          </a>
        </div>
      </div>

      {/* Mobile Menu Button */}
      <button
        onClick={toggleMenu}
        className="md:hidden absolute right-3 text-2xl top-10"
      >
        <FaBars />
      </button>

      {/* Sidebar Menu (Mobile) */}
      <div
        className={`fixed top-0 left-0 h-full w-64 bg-white shadow-lg transform ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 ease-in-out z-50`}
      >
        {/* Sidebar Header with Logo & Close Button */}
        <div className="flex items-center justify-between px-6 py-3 border-b">
          <img src={logo} className="w-50 h-14" alt="Sidebar Logo" />
          <button onClick={toggleMenu}>
            <IoCloseCircleOutline className="w-7 h-7" />
          </button>
        </div>

        {/* Sidebar Links */}
        <nav className="flex flex-col items-center mt-6 h-full space-y-2 px-6">
          <a
            href="#home"
            onClick={(e) => handleScroll(e, "home")}
            className="hover:text-green-500 font-[500] transition border-b w-full text-left py-2"
          >
            Home
          </a>
          <a
            href="#about"
            onClick={(e) => handleScroll(e, "about")}
            className="hover:text-green-500 font-[500] transition border-b w-full text-left py-2"
          >
            About
          </a>
          <a
            href="#ongoingProjects"
            onClick={(e) => handleScroll(e, "ongoingProjects")}
            className="hover:text-green-500 font-[500] transition border-b w-full text-left py-2"
          >
            On Going Projects
          </a>
          <a
            href="#upcomingPlotProjects"
            onClick={(e) => handleScroll(e, "upcomingProjects")}
            className="hover:text-green-500 font-[500] transition border-b w-full text-left py-2"
          >
            Upcoming Projects
          </a>
          <a
            href="#completedPlotProjects"
            onClick={(e) => handleScroll(e, "completedProjects")}
            className="hover:text-green-500 font-[500] transition border-b w-full text-left py-2"
          >
            Completed Projects
          </a>
          <a
            href="#plots"
            onClick={(e) => handleScroll(e, "plots")}
            className="hover:text-green-500 font-[500] transition border-b w-full text-left py-2"
          >
            Layout
          </a>
          <a
            href="#contact"
            onClick={(e) => handleScroll(e, "contact")}
            className="hover:text-green-500 font-[500] transition border-b w-full text-left py-2"
          >
            Contact
          </a>

          {/* Call Us with Icon (Mobile) */}
          <div className="flex items-center space-x-2 border-b w-full text-left py-2 ">
            <span className="font-medium text-lg text-[#03833e]">
              <a href="tel:+919160077777" className="flex items-center">
                <MdLocalPhone className="text-lg text-[#03833e] mt-[4%] pr-[2%]" />
                <div className="ml-2">
                  <p className="font-semibold">Call Us</p>
                  <p className="text-sm">9160077777</p>
                </div>
              </a>
            </span>
          </div>

          {/* Download Brochure Button (Mobile) */}
          <a
            onClick={handleDownloadBrochure}
            className="cursor-pointer group items-center bg-button px-6 py-3 rounded-2xl border bg-[#03833e] text-white hover:bg-[#03833e]-700 transition ease-in-out duration-500"
          >
            <div className="mr-3 montserrat">Download Brochure</div>
            <LuDownload className="block group-hover:hidden" />
            <LuDownload className="group-hover:block hidden" />
          </a>
        </nav>
      </div>

      {/* Overlay Background (Mask) */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={toggleMenu}
        ></div>
      )}
      {isPopupOpen && <Popup onClose={handleClosePopup} />}
    </div>
  );
};

export default Navbar;
